import { useEffect } from "react";
import { useApiGet, useApiPost } from "../../hooks";
import { isAPITotallyComplete } from "../../utilities/apiFunctions";

const AlfonsoSandbox = () => {
  const myInsuredIdTESTING = 15596;
  const { responseGet, dispatchGet } = useApiGet<number[]>(
    "api/Sandbox/GetTop10InsuredIdsByProgram"
  );
  const { responsePost, dispatchPost } = useApiPost(
    "api/Policy/RenewPoliciesForSpecificInsuredListTEST",
    responseGet.axiosResponse?.data?.concat(myInsuredIdTESTING) ?? []
  );
  const { responsePost: responsePost2, dispatchPost: dispatchPost2 } =
    useApiPost(`api/Policy/RenewPoliciesForSpecificInsuredListTEST`);

  useEffect(() => {
    dispatchGet();
  }, []);

  useEffect(() => {
    if (isAPITotallyComplete(responsePost)) {
      alert("COMPLETED");
    }
  }, [responsePost]);

  useEffect(() => {
    if (isAPITotallyComplete(responsePost2)) {
      alert("COMPLETED");
    }
  }, [responsePost2]);

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <button onClick={() => dispatchPost()}>
        Trigger API for top 10 insureds in specific program
      </button>
      <button onClick={() => dispatchPost2()}>
        Trigger API for all programs
      </button>
    </div>
  );
};

export default AlfonsoSandbox;
